import { t } from 'i18next';
import { useColumns } from '../../../../hook/useColumns';
import ColumnOrderRowOptions from './ColumnOrderRowOptions';
import { SetStateAction, useEffect, useRef } from 'react';
import close from '../../../../assets/img/png/health-monitor/close-button.png';
import { Visibility } from '../../../../enum/Visibility';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { persistColumnConfig } from '../../../../util/persist-column-config';

interface ColumnOrderProps {
  showDropdown: boolean;
  setShowDropdown: React.Dispatch<SetStateAction<boolean>>;
}

const ColumnOrderDropdown: React.FC<ColumnOrderProps> = ({ showDropdown, setShowDropdown }) => {
  const { pinnedColumns, unpinnedColumns } = useColumns();
  const dispatch = useAppDispatch();
  const wasOpen = useRef(false);

  useEffect(() => {
    if (wasOpen.current && !showDropdown) {
      persistColumnConfig(dispatch);
    }

    wasOpen.current = showDropdown;
  }, [showDropdown, dispatch]);

  return (
    <div className={`column_order_dropdown ${showDropdown ? Visibility.VISIBLE : Visibility.HIDDEN}`}>
      <div className="column_order_header">
        <span className="title">
          {t('statisticPage.header.columnOrder.title')}
          <button className="menu" onClick={() => setShowDropdown(false)}>
            <img src={close} alt="menu close" />
          </button>
        </span>

        <hr />
        <span className="pinned">
          {pinnedColumns.length} {t('statisticPage.header.columnOrder.pinned')}
        </span>
      </div>

      <div className="options_container">
        {pinnedColumns.map((col, i) => (
          <ColumnOrderRowOptions key={col.name} column={col} index={i} />
        ))}

        {pinnedColumns.length > 0 && unpinnedColumns.length > 0 && <hr />}

        {unpinnedColumns.map((col, i) => (
          <ColumnOrderRowOptions key={col.name} column={col} index={i} />
        ))}
      </div>
    </div>
  );
};

export default ColumnOrderDropdown;
